import React, { useEffect, useState } from 'react';

import { Container, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import useBlocRefHook from '../../utils/useBlocRef.hook';
import TableFooter from '../common/TableFooter';
import ResourcesHeader from '../resources/ResourcesHeader';
import ResourcesList from '../resources/ResourcesList';

const useStyles = makeStyles(() => ({
  container: {
    backgroundColor: '#FFFFFF',
    padding: '24px',
  },
}));

export default ({ onSelect, onCloseViewer }) => {
  const blocRef = useBlocRefHook('resourcesBloc');
  const [materials, setMaterials] = useState([]);
  const [criteria, setCriteria] = useState(blocRef.current.criteria$.getValue());
  const [materialCount, setMaterialCount] = useState(0);
  const [loadingResourceInfo, setLoadingResourceInfo] = useState();
  const classes = useStyles();

  useEffect(() => {
    blocRef.current.updateCriteria({ category: 'sharedStudy', type: null });
    const materialsSub = blocRef.current.materials$.subscribe(setMaterials);
    const criteriaSub = blocRef.current.criteria$.subscribe(setCriteria);
    const countSub = blocRef.current.materialCount$.subscribe(setMaterialCount);
    const resourceUpdateSub = blocRef.current.listenToResourceUpdate().subscribe();
    const loadingResourceInfoSub = blocRef.current.loadingResourceInfo$.subscribe(setLoadingResourceInfo);
    return () => {
      materialsSub.unsubscribe();
      criteriaSub.unsubscribe();
      countSub.unsubscribe();
      resourceUpdateSub.unsubscribe();
      loadingResourceInfoSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAddResource = () => blocRef.current.openAddResource();
  const handleCriteriaChange = (_criteria) => blocRef.current.updateCriteria(_criteria);
  const handleDeleteMaterial = (material) => blocRef.current.deleteMaterial(material);
  const handleEditMaterial = (material) => blocRef.current.openEditResource(material);
  const handleViewMaterial = (material) => blocRef.current.openViewer(material, { paper: classes.imagePaper }, { onClose: onCloseViewer });
  const handleRefresh = () => blocRef.current.refreshCriteria();
  const handleSelectMaterial = (material) => {
    if (!onSelect || typeof onSelect !== 'function') return;
    onSelect(material);
  };

  return (
    <div className={classes.container}>
      <Grid container component={Container} style={{ display: 'flex', marginTop: '30px' }}>
        <Grid item xs={12}>
          <ResourcesHeader
            disableType
            disableCategory
            disableAddResource
            shouldHideSelfHelpMaterials
            disableTemplateView
            onCriteriaChange={handleCriteriaChange}
            onAddResource={handleAddResource}
            newResources$={blocRef.current.newResources$}
            onRefresh={handleRefresh}
          />
        </Grid>
        <Grid item xs={12} className="mt-1">
          <ResourcesList
            disableEditButton
            disableDeleteButton
            onViewMaterial={handleViewMaterial}
            onDeleteMaterial={handleDeleteMaterial}
            onEditMaterial={handleEditMaterial}
            materials={materials}
            onSelectMaterial={handleSelectMaterial}
            isSelectable
            loadingResourceInfo={loadingResourceInfo}
          />
        </Grid>
        <Grid item xs={12}>
          <div style={{ textAlign: 'center' }}>
            <TableFooter count={materialCount} page={criteria.page} rowsPerPage={criteria.limit} changePage={(page) => handleCriteriaChange({ page })} />
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
